// moz667: por culpa de vrdemo
var $ = jQuery;

var is_on_execution = false;

// deshabilitamos las notificaciones cuando estemos en un streaming
var disabled_audit = $("body").hasClass("noaudit");

function set_cookie(cname, cvalue) {
    var d = new Date();
    d.setTime(d.getTime() + (24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function get_cookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }

    return "";
}

function next_audit_loop() {
    is_on_execution = false;
    setTimeout(audit_loop, 5000);
}

function audit_loop() {
    if (!is_on_execution) {
        is_on_execution = true;
    } else {
        return;
    }

    if (typeof N2M.AUDIT_PING_URL == 'undefined') {
        // console.log("NO logueado!!!");
        return;
    }

    var SECONDS_PERIOD = N2M.AUDIT_SECONDS_PERIOD;
    var date_now = new Date();
    var do_next_loop = false;
    var last_execution_date = get_cookie('audit_loop');
    
    if (last_execution_date) {
        last_execution_date = new Date(parseInt(last_execution_date));
    }

    if (!last_execution_date || (date_now.getTime() - last_execution_date.getTime()) > (SECONDS_PERIOD * 1000) ) {
        // console.log("audit GO!");
        var current_page = document && document.location ? document.location.pathname : 'unknown';

        $.ajax({
            method: "GET", // FIXME: hacer que sea POST, por ahora es GET ya que si no tenemos que lidiar con el CSRF
            url: N2M.AUDIT_PING_URL,
            data: {
                p: current_page
            }
        }).done(function(data) {
            set_cookie('audit_loop', (new Date()).getTime());
        }).always(function () {
            next_audit_loop();
        });
    } else {
        // Probamos la siguiente vez
        do_next_loop = true;
    }


    if (do_next_loop) {
        next_audit_loop();
    }
}

if (!disabled_audit) audit_loop();

/*
var seconds = 5;
var dateNow = new Date();
var date5SecondsAgo = new Date(dateNow.getTime() - seconds*1000);
*/